<template>
  <v-row no-gutters v-if="teacher">
    <v-app-bar class="d-md-none mb-2 white">
      <v-btn to="/teachers" icon>
        <v-icon left>mdi-arrow-left</v-icon>
      </v-btn>
      <h3>Hồ sơ</h3>
      <v-spacer></v-spacer>
      <div class="d-flex flex-row justify-end">
        <v-btn
          depressed
          medium
          class="primary--text mr-2"
          color="blue lighten-5"
          right
          @click="cancel"
          >Hủy</v-btn
        >
        <v-btn depressed medium color="primary" @click="save">Lưu</v-btn>
      </div>
    </v-app-bar>

    <v-col :class="{ 'text-center': $vuetify.breakpoint.smAndDown }" cols="12" md="4">
      <h2 class="mb-4">{{ teacher.name }}</h2>
      <user-avatar-picker v-if="teacher" :type="'teacher'" :student="teacher" :avatar="avatar" />
    </v-col>

    <v-col cols="12" md="8">
      <div>
        <div class="d-md-flex justify-space-between">
          <h3 class="mb-4">Thông tin cá nhân</h3>
          <div
            class="flex-row justify-end d-none d-md-flex"
            v-if="['super_admin', 'education_manager'].includes(role.type)"
          >
            <v-btn
              depressed
              medium
              class="primary--text mr-2"
              color="blue lighten-5"
              right
              @click="cancel"
              >Hủy</v-btn
            >
            <v-btn depressed medium color="primary" @click="save">Lưu</v-btn>
          </div>
        </div>
        <h4>Thông tin liên lạc</h4>
        <teacher-info-form ref="teacherInfoForm" :teacher="teacher" />
        <h4>Thông tin cơ bản</h4>
        <teacher-general-form ref="teacherGeneralForm" :teacher="teacher" />
        <h4>Thông tin người liên hệ khẩn cấp</h4>
        <teacher-sos-form ref="teacherSosForm" :teacher="teacher" />
        <h4>Công ty hiện tại</h4>
        <teacher-company-form ref="teacherCompanyForm" :teacher="teacher" />
        <h4>Thông tin ngân hàng</h4>
        <teacher-bank-form ref="teacherBankForm" :teacher="teacher" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import TeacherInfoForm from '@/components/basic/form/TeacherInfoForm'
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import TeacherGeneralForm from '@/components/basic/form/TeacherGeneralForm'
import TeacherSosForm from '@/components/basic/form/TeacherSOSForm'
import TeacherCompanyForm from '@/components/basic/form/TeacherCompanyForm'
import TeacherBankForm from '@/components/basic/form/TeacherBankForm'

export default {
  components: {
    TeacherInfoForm,
    UserAvatarPicker,
    TeacherGeneralForm,
    TeacherSosForm,
    TeacherCompanyForm,
    TeacherBankForm
  },
  props: {
    teacher: Object
  },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    ...mapGetters('teacher', ['avatar']),
    ...mapState('auth', ['profile', 'role'])
  },
  methods: {
    ...mapActions('teacher', ['updateTeacher']),
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    save() {
      if (!['super_admin', 'education_manager'].includes(this.role.type)) {
        return
      }

      const valid1 = this.$refs.teacherInfoForm.validate()
      const valid2 = this.$refs.teacherGeneralForm.validate()
      const valid3 = this.$refs.teacherSosForm.validate()
      const valid4 = this.$refs.teacherCompanyForm.validate()
      const valid5 = this.$refs.teacherBankForm.validate()

      const isValid = valid1 && valid2 && valid3 && valid4 && valid5

      if (!isValid) {
        return
      }

      const teacherInfo = this.$refs.teacherInfoForm.getData()
      const teacherGeneralForm = this.$refs.teacherGeneralForm.getData()
      const teacherSosForm = this.$refs.teacherSosForm.getData()
      const teacherCompanyForm = this.$refs.teacherCompanyForm.getData()
      const teacherBankForm = this.$refs.teacherBankForm.getData()

      const payload = {
        id: this.teacher.id,
        ...teacherInfo,
        majors: teacherGeneralForm.majors,
        metadata: {
          ...teacherGeneralForm,
          ...teacherSosForm,
          ...teacherCompanyForm,
          ...teacherBankForm
        }
      }
      this.updateTeacher(payload)
    },
    cancel() {
      this.state = false
      this.$router.back()
    }
  }
}
</script>
